module.exports = __webpack_public_path__ + "static/img/alpaga-02.5925a1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpaga-02.png
// module id = 61
// module chunks = 0